var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 9.211,
    viewBox: "0 0 12 9.211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Check",
    d: "M13.8,5.186a.694.694,0,0,0-.982-.982L5.485,11.533l-2.3-2.3a.694.694,0,1,0-.982.982l2.756,2.756c.011.012.022.024.033.035a.7.7,0,0,0,.984,0,.4.4,0,0,0,.033-.035Z",
    transform: "translate(-2 -4)",
    fill: "#deb851",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.df056fe6822c2cfcebd7fa8b4a7175db.svg";
export { ForwardRef as ReactComponent };